(function () {
  if (customElements.get('load-more-grid')) return;

  class LoadMoreGrid extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('[data-load-more-button]');
      if (!this.button) return;
      this.onClick = this.handleClick.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button && this.onClick) {
        this.button.removeEventListener('click', this.onClick);
      }
    }

    handleClick(event) {
      event.preventDefault();
      if (this.classList.contains('is-loading')) return;

      var nextUrl = this.dataset.nextUrl;
      var sectionId = this.dataset.sectionId;
      var gridSelector = this.dataset.grid || '#ProductGridContainer ul.product-grid';
      if (!nextUrl || !sectionId) return;

      var url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      this.setLoading(true);

      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('load-more');
          return response.text();
        })
        .then(
          function (responseText) {
            var html = new DOMParser().parseFromString(responseText, 'text/html');
            var sourceGrid = html.querySelector(gridSelector);
            var targetGrid = document.querySelector(gridSelector);
            if (!sourceGrid || !targetGrid) return;

            var items = sourceGrid.querySelectorAll(':scope > li');
            Array.prototype.forEach.call(items, function (item) {
              targetGrid.appendChild(item);
            });

            var nextControl = html.querySelector('load-more-grid');
            if (nextControl && nextControl.dataset.nextUrl) {
              this.dataset.nextUrl = nextControl.dataset.nextUrl;
            } else {
              this.remove();
            }
          }.bind(this)
        )
        .catch(function () {})
        .finally(
          function () {
            if (this.isConnected) this.setLoading(false);
          }.bind(this)
        );
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      this.button.disabled = isLoading;
      this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      var spinner = this.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !isLoading);
    }
  }

  customElements.define('load-more-grid', LoadMoreGrid);
})();
